export default "__VITE_ASSET__D0b1EFfw__"